// extracted by mini-css-extract-plugin
export default {"uiLoader":"loaders_uiLoader__HH3zH"};